import { fromConsignmentDetailDetailedResponse, toConsignmentDetailRequest } from '../models/mapper'
import { ConsignmentDetailUpdate } from '../models/request'
import { ConsignmentDetailDetails } from '../models/types'
import { createConsignmentDetailDraftV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createConsignmentDetailDraft(update: ConsignmentDetailUpdate): Promise<ConsignmentDetailDetails> {
  const response = await createConsignmentDetailDraftV2(toConsignmentDetailRequest(update))
  return fromConsignmentDetailDetailedResponse(response, update.target)
}
